define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/XMLUtil',
	'model/AuthenticationOption',
	'model/RequestedAttribute',
	'model/Image',
	'factory/AttributesFactory',
	'factory/RequestedAttributesFactory',
	'lib/jquery'
], function (
		Logger,
		Util,
		XMLUtil,
		AuthenticationOption,
		RequestedAttribute,
		Image,
		AttributesFactory,
		RequestedAttributesFactory,
		jQuery
		) {
	'use strict';

	/**
	 * AuthenticationOptionsFactory class
	 */
	return new function () {
		var privacyProfileNamespace = 'urn:oasis:names:tc:SAML:profile:privacy',
				metadataUiNamespace = 'urn:oasis:names:tc:SAML:metadata:ui',
				 assertionNamespace = "urn:oasis:names:tc:SAML:2.0:assertion";


		// private methods

		function getIssuer(issuerNodes) {
			var issuer = new Array(),
					i;

			if (issuerNodes.length === 0) {
				return null;
			}

			for (i = 0; i < issuerNodes.length; i++) {
				issuer.push(issuerNodes[i].textContent);
			}

			return issuer;
		}


		/**
		 * Create an AuthenticationOption object from the given XML.
		 * 
		 * @param {string} authenticationOption Raw authentication option.
		 * @param {jQuery} optionsXML Options (EntityDescriptor) needed to create requested attributes.
		 * @returns {AuthenticationOption}
		 */
		function createAuthenticationOption (authenticationOption, optionsXML) {
			var uiInfo = null,
					logo = null,
					id = null,
					activation = null,
					type = null,
					protocol = null,
					issuer = null,
					description = null,
					image = null,
					attributes = null,
					requestedAttributes = null,
					authnContextClassRef = "urn:oasis:names:tc:SAML:2.0:ac:classes:unspecified",
					derivedCredential = Array(),
					authenticationOptionXML,
					i,
					result;
			
			authenticationOptionXML = jQuery(authenticationOption);

			uiInfo = XMLUtil.find(metadataUiNamespace, authenticationOptionXML, 'UIInfo', true);
			if (uiInfo.length > 0) {
				description = XMLUtil.find(metadataUiNamespace, uiInfo, 'DisplayName').text().trim();
				logo = XMLUtil.find(metadataUiNamespace, uiInfo, 'Logo');
				image = new Image(logo.text().trim(), logo.attr('width'), logo.attr('height'));
			}

			id = authenticationOptionXML.attr('AuthenticationOptionID').trim();
			activation = authenticationOptionXML.attr('ActivationType').trim();
			type = XMLUtil.find(privacyProfileNamespace, authenticationOptionXML, 'Type', true).text().trim();
			protocol = XMLUtil.find(privacyProfileNamespace, authenticationOptionXML, 'Protocol', true).text().trim();
			issuer = getIssuer(XMLUtil.find(privacyProfileNamespace, authenticationOptionXML, 'Issuer', true));
			attributes = AttributesFactory.create(authenticationOptionXML);
			requestedAttributes = RequestedAttributesFactory.createForAuthenticationOption(optionsXML, authenticationOptionXML);
			authnContextClassRef = XMLUtil.find(assertionNamespace, authenticationOptionXML, 'AuthnContextClassRef', true).text().trim();
			
			if (attributes.length === 0) {
				attributes = null;
			}

			var tmpCredentials = XMLUtil.find(privacyProfileNamespace, authenticationOptionXML, 'DerivedCredential');

			for (i = 0; i < tmpCredentials.length; i++) {
				derivedCredential.push(createAuthenticationOption(tmpCredentials[i], optionsXML));
			}

			result = new AuthenticationOption(
					id,
					activation,
					type,
					protocol,
					issuer,
					description,
					image,
					attributes,
					requestedAttributes,
					derivedCredential,
					authnContextClassRef);
			RequestedAttributesFactory.resolveOrigins(result);
			return result;
		}

		// public methods

		this.create = function (optionsXML) {
			var authenticationOptions = new Array(),
					authenticationOptionsXML = null,
					i;

			authenticationOptionsXML = XMLUtil.find(privacyProfileNamespace, optionsXML, 'AuthenticationOption');

			if (authenticationOptionsXML === null) {
				return authenticationOptions;
			}

			for (i = 0; i < authenticationOptionsXML.length; i++) {
				authenticationOptions.push(createAuthenticationOption(authenticationOptionsXML[i], optionsXML));
			}

			return authenticationOptions;
		};

		this.createFromObject = function (authenticationOptionObject) {
			var authenticationOptions,
					requestedAttributes = Array(),
					derivedCredential = Array(),
					i;

			if (authenticationOptionObject.hasOwnProperty('requestedAttributes')) {
				for (var j = 0; j < authenticationOptionObject['requestedAttributes'].length; j++) {
					requestedAttributes.push(new RequestedAttribute(
							authenticationOptionObject['requestedAttributes'][j]['name'],
							authenticationOptionObject['requestedAttributes'][j]['isRequired'],
							authenticationOptionObject['requestedAttributes'][j]['purpose']));
				}
			}

			if (authenticationOptionObject.hasOwnProperty('derivedCredential')) {
				for (var j = 0; j < authenticationOptionObject['derivedCredential'].length; j++) {
					derivedCredential.push(this.createFromObject(authenticationOptionObject['derivedCredential'][j]));
				}
			}

			// TODO: check this seems fishy
			if (Util.isArray(authenticationOptionObject)) {
				authenticationOptions = new Array();

				for (i = 0; i < authenticationOptionObject.length; i++) {
					var img = null;
					if (authenticationOptionObject[i]['image'] !== null) {
						img = new Image(authenticationOptionObject[i]['image']['url'],
								authenticationOptionObject[i]['image']['width'],
								authenticationOptionObject[i]['image']['height']);
					}
					authenticationOptions.push(new AuthenticationOption(
							authenticationOptionObject[i]['id'],
							authenticationOptionObject[i]['activation'],
							authenticationOptionObject[i]['type'],
							authenticationOptionObject[i]['protocol'],
							authenticationOptionObject[i]['issuer'],
							authenticationOptionObject[i]['description'],
							img,
							(authenticationOptionObject[i]['attributes'] !== null ?
									AttributesFactory.createFromObject(authenticationOptionObject[i]['attributes']) : null),
							requestedAttributes,
							derivedCredential));
				}
			} else {
				var img = null;
				if (authenticationOptionObject['image'] !== null) {
					img = new Image(authenticationOptionObject[i]['image']['url'],
							authenticationOptionObject[i]['image']['width'],
							authenticationOptionObject[i]['image']['height']);
				}
				authenticationOptions = new AuthenticationOption(
						authenticationOptionObject['id'],
						authenticationOptionObject['activation'],
						authenticationOptionObject['type'],
						authenticationOptionObject['protocol'],
						authenticationOptionObject['issuer'],
						authenticationOptionObject['description'],
						img,
						(authenticationOptionObject['attributes'] !== null ?
								AttributesFactory.createFromObject(authenticationOptionObject['attributes']) : null),
						requestedAttributes,
						derivedCredential);
			}

			return authenticationOptions;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/factory/AuthenticationOptionsFactory.js
// module id = 62
// module chunks = 8